import type Lenis from "lenis";

/**
 * Tiny shared store for the active Lenis instance so non-MotionProvider
 * components (e.g. the mobile menu) can pause/resume smooth scrolling
 * without prop-drilling. MotionProvider sets it on mount and clears it on
 * unmount; everyone else reads via getLenis().
 */
let instance: Lenis | null = null;

export function setLenis(lenis: Lenis | null) {
  instance = lenis;
}

export function getLenis(): Lenis | null {
  return instance;
}
